import React from 'react';
import ItemList from './ItemList';
import AddItemForm from './AddItemForm';
import { Plus, X } from 'lucide-react';

const ContentArea = ({ activeSection, showForm, setShowForm, faqs, utterances, answers, user, onDataUpdate }) => {
  const items = activeSection === 'faq' ? faqs : activeSection === 'utterance' ? utterances : answers;

  return (
    <div className="w-3/4 p-4 flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">
          {activeSection === 'faq' ? 'FAQs' : activeSection === 'utterance' ? 'Utterances' : 'Answers'}
        </h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className={`${showForm ? 'bg-gray-500' : 'bg-blue-500'} text-white px-3 py-1 rounded-full text-sm flex items-center`}
        >
          {showForm ? (
            <>
              <X size={16} className="mr-1" /> Cancel
            </>
          ) : (
            <>
              <Plus size={16} className="mr-1" /> Add New
            </>
          )}
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        <ItemList items={items} itemType={activeSection} />
      </div>
      {showForm && (
        <AddItemForm
          activeSection={activeSection}
          user={user}
          onSubmitSuccess={onDataUpdate}
          onCancel={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default ContentArea;